import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon LockIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const LockIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 15 20">
      <path d="M12.69,7.48h-0.17v-3c0.09-1.18-0.31-2.35-1.1-3.23C10.36,0.34,8.98-0.11,7.59,0c-4.93,0-4.95,3.33-5,4.42v0.17 c0,0.75,0,2.13,0,2.89H2.31C1.04,7.47,0.01,8.49,0,9.76v8c0.03,1.25,1.06,2.25,2.31,2.24h10.38c1.27,0.01,2.3-1.01,2.31-2.28v-8 C14.97,8.47,13.94,7.47,12.69,7.48z M4.36,4.63V4.44c0-1.16,0-2.73,3.23-2.73c0.93-0.09,1.86,0.18,2.6,0.76 c0.46,0.56,0.67,1.28,0.6,2v3H4.36C4.35,6.73,4.35,5.36,4.36,4.63z M13.27,17.72c0,0.31-0.26,0.57-0.57,0.57c0,0-0.01,0-0.01,0H2.31 C2,18.3,1.74,18.04,1.73,17.73c0,0,0-0.01,0-0.01v-8c0-0.31,0.26-0.57,0.57-0.57c0,0,0.01,0,0.01,0h10.38 C13,9.14,13.26,9.4,13.27,9.71c0,0,0,0.01,0,0.01L13.27,17.72z" />
      <path d="M7.5,12c-0.9-0.06-1.67,0.62-1.73,1.52c0.01,0.48,0.25,0.92,0.65,1.19v0.78c0,0.6,0.48,1.08,1.08,1.08 c0.6,0,1.08-0.48,1.08-1.08v-0.78c0.4-0.27,0.64-0.71,0.65-1.19C9.17,12.62,8.4,11.94,7.5,12z" />
    </Icon>
  )
}
export default LockIcon
